import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const GET_SOLD_TO_BY_ID = gql`
  query GetSoldToByID($id: String!) {
    soldTo(id: $id) {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
    }
  }
`;

const GET_SHIP_TO_BY_ID = gql`
  query GetShipToById($id: String!) {
    shipTo(id: $id) {
      id
      salesOrg
      address {
        name
        street
        city
        postalCode
        region
        country
      }
      smhActiveUser
      vmiIndicator
    }
  }
`;

const useSoldToShipTo = ({
  soldToId,
  shipToId,
}: {
  soldToId: string;
  shipToId?: string;
}) => {
  const soldTo = useQuery(GET_SOLD_TO_BY_ID, {
    variables: {
      id: soldToId,
    },
  });

  const shipTo = useQuery(GET_SHIP_TO_BY_ID, {
    skip: !shipToId,
    variables: {
      id: shipToId,
    },
  });

  return {
    soldTo,
    shipTo,
    loading: soldTo.loading || shipTo.loading,
    error: soldTo.error || shipTo.error,
  };
};

export { useSoldToShipTo };
